import styled from '@emotion/styled'
import { Select as AntSelect, Button } from 'antd'
import checkIcon from '@slerp/assets/check.svg'

export const Select = styled(AntSelect)`
  &.ant-select.ant-select:not(.ant-select-customize-input)
    > div.ant-select-selector {
    padding-left: 4px;
  }

  &.ant-select.ant-select-multiple.ant-select:not(.ant-select-customize-input)
    > div.ant-select-selector {
    padding-left: 4px;
  }

  &.ant-select.ant-select-single.ant-select:not(.ant-select-customize-input)
    > div.ant-select-selector {
    padding-left: 12px;
  }

  &.ant-select.ant-select-disabled {
    .ant-select-selector,
    .ant-select-selector:hover {
      border: none;
      box-shadow: none;
    }
  }
`

export const SelectDropDown = styled.div`
  .ant-select-item-option:first-of-type {
    font-weight: 600;
  }

  .ant-select-item-option {
    display: flex;
    align-items: center;
    gap: 8px;

    font-weight: 500;

    &::before {
      content: '';
      display: block;
      height: 16px;
      width: 16px;
      border: 1px solid #dbd9df;
      border-radius: 4px;
      box-shadow: 0px 2px 2px -1px #4a4a681a inset;
    }
  }

  .ant-select-item-option-selected {
    &::before {
      content: '';
      background-image: url(${checkIcon});
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
`

export const SelectButton = styled(Button)`
  width: 100%;
`
